import React from "react";
import { TextareaContainer, TextareaGeneral, Label, LabelIcon } from "./styles";
import {
  ErrorMessage,
  FormController,
} from "../../../assets/global/globalStyles";
import useFormType from "../../../hooks/useFormType";

/**
 * @param props
 * @param {String} props.name
 * @param {String} props.label
 */
export default function Textarea({
  name,
  label,
  children,
  grid,
  gridRow,
  ...rest
}) {
  const { fieldName, defaultValue, error, ref, location } = useFormType(name);

  return (
    <FormController grid={grid} gridRow={gridRow}>
      <TextareaContainer error={error}>
        <Label htmlFor={fieldName} className="placeholder">
          {label}
        </Label>
        <TextareaGeneral
          location={location.pathname}
          defaultValue={defaultValue}
          autoComplete="off"
          id={fieldName}
          error={error}
          ref={ref}
          {...rest}
        />
        {error && <ErrorMessage>{error}</ErrorMessage>}
        {children && <LabelIcon>{children}</LabelIcon>}
      </TextareaContainer>
    </FormController>
  );
}
